// src/components/Layout.tsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import AppNavbar from './Navbar';
import Footer from './Footer';
import { Container } from 'react-bootstrap';

const Layout: React.FC = () => {
  return (
    <div className="d-flex flex-column min-vh-100">
      <AppNavbar />
      <Container className="py-4 flex-grow-1">
        <Outlet />
      </Container>
      <Footer />
    </div>
  );
};

export default Layout;